<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="fill-height" fluid>
        <div class="tab-content">
          <div id="terms-services" class="tab-pane fade in active">
            <div class="policy">
              <h2>
                Privacy Policy
                <m></m>
              </h2>
              <div class id="renderContent">
                <meta charset="utf-8" />
                <meta http-equiv="X-UA-Compatible" content="IE=edge" />
                <meta
                  name="viewport"
                  content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                />

                <div>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Truck tries hard to make your business growth smoothly. Our Privacy Policy provide the latest information about the data we collect and how we use it.</font>
                  </p>
                  <p>
                    <br />
                  </p>
                  <h2>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Data Collections And Uses</font>
                  </h2>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >This policy applies to users of Truck's services anywhere in the world, including users of Truck's apps, websites, features or other services.</font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >This policy describes how Truck and its affiliates collect and use personal information to provide our services. This policy applies to all users of our apps, websites, features or other services anywhere in the world, unless covered by a separate privacy policy. This policy specifically applies to:</font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>Customers</b>: users who request or receive transportation
                    </font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>Drivers</b>: users who provide transportation individually or through partner transportation companies
                    </font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>Admin Users</b>: users who are supervisors of our corporate clients, who manage their day to day operation via Truck App
                    </font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >This policy also applies to those who provide information to Truck in connection with an application to use our services, or whose information Truck otherwise receives in connection with its services (such as contact information of individuals associated with Clients of Fleet Management Solution). All those subject to this policy are referred to as “users” for purposes of this policy.</font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >The practices described in this policy are subject to applicable laws in the places in which we operate. This means that we only engage in the practices described in this policy in a particular country or region if permitted under the laws of those places. Please contact us if you have questions on our practices in your country or region.</font>
                  </p>
                  <p>
                    <br />
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>Truck collects:</b>
                    </font>
                  </p>
                  <p></p>
                  <span
                    style="font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif;"
                  >- Information that you provide to Truck, such as when you create your Truck account.</span>
                  <br />
                  <span
                    style="font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif;"
                  >- Information created when you use our services, such as location, usage and device information.</span>
                  <br />
                  <span
                    style="font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif;"
                  >- Information from other sources, such as from your employeer or service provider when fill in your details to provide you transport services.</span>
                  <br />
                  <p></p>
                  <p>
                    <br />
                  </p>
                  <h3>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >The following information is collected by or on behalf of Truck:</font>
                  </h3>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>User profile</b>: We collect information when you create or update your Truck account. This may include your name, email, phone number, login name and password, address, payment or banking information (including related payment verification information), government identification numbers such as Social Security number, driver’s license or passport if required by law, birth date, photo and signature. This also includes vehicle or insurance information of drivers. This also includes the preferences and settings that you enable for your Truck account.
                    </font>
                  </p>
                  <p>
                    <span
                      style="font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif;"
                    >
                      <b>Background check information</b>: We may collect background check information if you sign up to use Truck's services as a driver or service provider. This may include information such as your driver history or criminal record (where permitted by law). This information may be collected by a vendor on Truck’s behalf.
                    </span>
                    <br />
                  </p>
                  <p>
                    <span
                      style="font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif;"
                    >
                      <b>Demographic data</b>: We may collect demographic information about you, including through user surveys. In some countries, we may also receive demographic information about you from third parties.
                    </span>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>User content</b>: We may collect information that you submit when you contact Truck customer support, provide ratings or compliments for other users, or otherwise contact Truck.
                    </font>
                  </p>
                  <p>
                    <br />
                  </p>
                  <h3>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Information created when you use our services</font>
                  </h3>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>Location Information</b>
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Depending on the Truck services that you use, and your app settings or device permissions, we may collect your precise or approximate location information as determined through data such as GPS, IP address and WiFi.</font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >If you are a driver or Supervisor(Admin User), Truck collects location information when the Truck app is running in the foreground (app open and on-screen) or background (app open but not on screen) of your device.</font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >If you are a rider and have provided permission for the processing of location data, Truck collects location information when the Truck app is running in the foreground. In certain regions, Truck also collects this information when the Truck app is running in the background of your device if this collection is enabled through your app settings or device permissions.</font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Customers may use the Truck app without enabling Truck to collect their location information. However, this may affect the functionality available on your Truck app. For example, if you do not enable Truck to collect your location information, you will have to manually enter your pickup address. In addition, location information will be collected from the driver during your trip and linked to your account, even if you have not enabled Truck to collect your location information.</font>
                  </p>
                  <p>
                    <br />
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>Transaction Information</b>
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >We collect transaction details related to your use of our services, including the type of services you requested or provided, your order details, delivery information, date and time the service was provided, amount charged, distance traveled, and payment method. Additionally, if someone uses your promotion code, we may associate your name with that person.</font>
                  </p>
                  <p>
                    <br />
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>Usage information</b>
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >We collect information about how you interact with our services. This includes information such as access dates and times, app features or pages viewed, app crashes and other system activity, type of browser, and third-party sites or service you were using before interacting with our services.&nbsp;</font>
                  </p>
                  <p>
                    <br />
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>Device Information</b>
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >We may collect information about the devices you use to access our services, including the hardware models, device IP address, operating systems and versions, software, file names and versions, preferred languages, unique device identifiers, advertising identifiers, serial numbers, device motion information, and mobile network information.</font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>Communications data</b>
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >We enable users to communicate with each other and Truck through the Truck apps, websites, and other services. For example, we enable drivers and customers, and Admin Users and recipients, to call or text each other (in some countries, without disclosing their telephone numbers to each other). To provide this service, Truck receives some information regarding the calls or texts, including the date and time of the call/text, and the content of the communications. Truck may also use this information for customer support services (including to resolve disputes between users), for safety and security purposes, to improve our products and services and for analytics.</font>
                  </p>
                  <p>
                    <br />
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>Information from other sources</b>
                    </font>
                  </p>
                  <p></p>
                  <ul>
                    <li>
                      <span
                        style="font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif;"
                      >User feedback, such as as ratings or compliments.</span>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Users providing your information in connection with referral programs.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Users requesting services for or on your behalf.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Users or others providing information in connection with claims or disputes.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Truck business partners through which you create or access your Truck account, such as payment providers, social media services, on-demand music services, or apps or websites who use Truck’s APIs or whose API Truck uses.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Insurance providers (if you are a driver ).</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Financial services providers (if you are a driver).</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Partner transportation companies (if you are a driver who uses our services through an account associated with such a company).</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Publicly available sources.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Marketing service providers.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Truck may combine the information collected from these sources with other information in its possession.</font>
                    </li>
                  </ul>
                  <p></p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <br />
                  </p>
                  <h3>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >How We Use Your Information</font>
                  </h3>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Truck collects and uses information to enable reliable and convenient transportation, delivery and other products and services. We also use the information we collect:</font>
                  </p>
                  <p></p>
                  <ul>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >To enhance the safety and security of our users and services</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >For customer support</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >For research and development</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >To enable communications to or between users</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >To provide promotions or contests</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >In connection with legal proceedings</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Truck does not sell or share your personal information to third parties for third party direct marketing purposes.</font>
                    </li>
                  </ul>
                  <p></p>
                  <p>
                    <br />
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Truck uses the information it collects for purposes including:</font>
                  </p>
                  <p>
                    <span
                      style="font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif;"
                    >
                      <b>Providing services and features</b>
                    </span>
                    <br />
                  </p>
                  <p>
                    <span
                      style="font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif;"
                    >Truck uses the information we collect to provide, personalize, maintain and improve our products and services. This includes using the information to:</span>
                    <br />
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p></p>
                  <ul>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Create and update your account.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Verify your identity.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Enable transportation, deliveries, and other services. This includes automated processing of your information to enable Dynamic Pricing, in which the price of a ride is determined based on constantly varying factors such as the estimated time and distance of the predicted route, estimated traffic, and the number of customers and drivers using Truck at a given moment.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Process or facilitate payments for those services.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >To track the progress of your ride.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Enable features that allow you to share information with other people, such as when you submit a compliment about a driver, refer a friend to Truck, split fares, or share your ETA.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Enable features to personalize your Truck account, such as creating bookmarks for your favorite places, and to enable quick access to previous destinations.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Enable Accessibility features that make it easier for users with disabilities to use our services, such as those which enable deaf or hard-of-hearing drivers to alert their customers of their disabilities, allow only text messages from customers, and to receive flashing trip request notifications instead of sound notifications.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Perform internal operations necessary to provide our services, including to troubleshoot software bugs and operational problems, to conduct data analysis, testing, and research, and to monitor and analyze usage and activity trends.</font>
                    </li>
                  </ul>
                  <p></p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>Safety and security</b>
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >We use your data to help maintain the safety, security and integrity of our services and users. This includes, for example:</font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Screening drivers prior to enabling their use of our services and at subsequent intervals, including through reviews of background checks where permitted by law, to prevent use of our services by unsafe drivers.</font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Using information from drivers’ devices to identify unsafe driving behavior such as speeding or harsh braking and acceleration, and to raise awareness among drivers regarding such behaviors.</font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >our Real-Time ID Check feature, which prompts drivers to share a selfie before going online. This helps ensure that the driver using the app matches the Truck account we have on file, preventing fraud and helping to protect other users.</font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Using device, location, profile, usage and other information to prevent, detect, and combat fraud or unsafe activities. This includes processing of such information, in certain countries, to identify practices or patterns that indicate fraud or risk of safety incidents. This may also include information from third parties. In certain cases such incidents may lead to deactivation by means of an automated decision making process.</font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Using user ratings to encourage improvement by affected users, and as grounds for deactivating users with ratings below a certain minimum as may be required in their region. Calculation and deactivation may be done through an automated decision making process.&nbsp;</font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>Customer support</b>
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Truck uses the information we collect (including recordings of customer support calls after notice to you and with your consent) to assist you when you contact our customer support services, including to:</font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p></p>
                  <ul>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Direct your questions to the appropriate customer support person</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Investigate and address your concerns</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Monitor and improve our customer support responses</font>
                    </li>
                  </ul>
                  <p></p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>Research and development</b>
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >We may use the information we collect for testing, research, analysis and product development. This allows us to improve and enhance the safety and security of our services, develop new features and products, and facilitate insurance and finance solutions in connection with our services.</font>
                  </p>
                  <p>
                    <span
                      style="font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif;"
                    >
                      <b>Communications from Truck</b>
                    </span>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Truck may use the information we collect to communicate with you about products, services, promotions, studies, surveys, news, updates and events.</font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Truck may also use the information to promote and process contests and sweepstakes, fulfill any related awards, and serve you relevant ads and content about our services and those of our business partners. You may receive some of these communications based on your profile as an Truck user.&nbsp;</font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Truck may also use the information to inform you about elections, ballots, referenda and other political and policy processes that relate to our services.</font>
                  </p>
                  <p>
                    <br />
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>Legal proceedings and requirements</b>
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >We may use the information we collect to investigate or address claims or disputes relating to your use of Truck's services, or as otherwise allowed by applicable law, or as requested by regulators, government entities, and official inquiries.</font>
                  </p>
                  <p>
                    <b
                      style="font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif;"
                    >
                      <br />
                    </b>
                  </p>
                  <p>
                    <b
                      style="font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif;"
                    >Cookies And Third Party Technologies</b>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Truck and its partners use cookies and other identification technologies on our apps, websites, emails, and online ads for purposes described in this policy.</font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Cookies are small text files that are stored on your browser or device by websites, apps, online media, and advertisements. Truck uses cookies and similar technologies for following purposes:</font>
                  </p>
                  <p></p>
                  <ul>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Authenticating users</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Remembering user preferences and settings</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Determining the popularity of content</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Delivering and measuring the effectiveness of advertising campaigns of out services and our partner services only.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Analyzing site traffic and trends, and generally understanding the online behaviors and interests of people who interact with our services.&nbsp;</font>
                    </li>
                  </ul>
                  <p></p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>Information Sharing And Disclosure</b>
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Some of Truck's products, services and features require that we share information with other users or at your request. We may also share your information with our affiliates, subsidiaries and business partners, for legal reasons or in connection with claims or disputes.</font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>Truck may share the information:</b>
                    </font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>With other users</b>
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >For example, if you are a rider, we may share your first name, average rider rating given by drivers, and pickup and/or dropoff locations with drivers. If you share an ride trip with another rider, that rider may be told your name and may see your pickup and/or dropoff location.</font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >If you are a driver or admin user, we may share information with your rider(s) including name and photo; vehicle make, model, color, license plate, and vehicle photo; location; average rating provided by customers; total number of trips; for how long you have been using the Truck app; and contact information (depending upon applicable laws). If you choose to complete a driver profile, we may also share any information associated with that profile, including information that you submit and compliments that past customers have submitted about you. The rider recipient will also receive a receipt containing information such as a breakdown of amounts charged, your first name, photo, and a map of the route you took.</font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>On your request we share information with:</b>
                    </font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Other people at your request. For example, we may share your ETA and location with a friend at your request, or your trip information when you split a fare with a friend.</font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Truck business partners. For example, if you requested a service through a partnership or promotional offering made by a third party, Truck may share your information with those third parties. This may include, for example, other apps or websites that integrate with our APIs, vehicle suppliers, or services, or those with an API or service with which we integrate, or business partners with whom Truck may partner with to deliver a promotion, a contest or a specialized service.</font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>With the general public when you submit content to a public forum</b>
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >We love hearing from our users -- including through public forums such as Truck blogs, social media, and certain features on our network. When you communicate with us through those channels, your communications may be viewable by the public with the owner of Truck accounts that you may use.</font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >If you use a profile associated with another party we may share your trip information with the owner of that profile. This occurs, for example, if you are:</font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p></p>
                  <ul>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >A customer using your employer’s Truck for Business profile, or taking trips arranged through Truck or It's Business partner or Truck's Transport providers, or Truck's Transport Clients.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >A driver using an account owned by a partner transportation company.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >A rider who takes a trip arranged by a friend or under a Family Profile.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >With Truck subsidiaries and affiliates</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >We share information with our subsidiaries and affiliates to help us provide our services or conduct data processing on our behalf. For example, Truck processes and stores information in India on behalf of its international subsidiaries and affiliates.</font>
                    </li>
                  </ul>
                  <p></p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>With Truck service providers and business partners</b>
                    </font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Truck may provide information to its vendors, consultants, marketing partners, research firms, and other service providers or business partners. This may include, for example:</font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p></p>
                  <ul>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Payment processors and facilitators.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Background check providers (drivers and delivery partners only).</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Cloud storage providers.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Marketing partners and marketing platform providers.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Data analytics providers.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Research partners, including those performing surveys or research projects in partnership with Truck or on Truck’s behalf.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Vendors that assist Truck to enhance the safety and security of its apps.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Consultants, lawyers, accountants and other professional service providers.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Fleet partners.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Insurance and financing partners.</font>
                    </li>
                    <li>
                      <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">Airports.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Local taxi providers.</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >Vehicle solution vendors or third party vehicle suppliers.</font>
                    </li>
                  </ul>
                  <p></p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>For legal reasons or in the event of a dispute</b>
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Truck may share your information if we believe it is required by applicable law, regulation, operating agreement, legal process or governmental request, or where the disclosure is otherwise appropriate due to safety or similar concerns.</font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >This includes sharing your information with law enforcement officials, government authorities, airports (if required by the airport authorities as a condition of operating on airport property), or other third parties as necessary to enforce our Terms of Service, user agreements, or other policies, to protect Truck’s rights or property or the rights, safety or property of others, or in the event of a claim or dispute relating to your use of our services. If you use another person’s credit card, we may be required by law to share information with that credit card holder, including trip information.</font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >This also includes sharing your information with others in connection with, or during negotiations of, any merger, sale of company assets, consolidation or restructuring, financing, or acquisition of all or a portion of our business by or into another company.</font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>With your consent</b>
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Truck may share your information other than as described in this policy if we notify you and you consent to the sharing.</font>
                  </p>
                  <p>
                    <br />
                  </p>
                  <h3>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >User Settings And Transparency</font>
                  </h3>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Truck provides means for you to see and control the information that Truck collects, including through:</font>
                  </p>
                  <p></p>
                  <ul>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >in-app privacy settings</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >device permissions</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >in-app ratings pages</font>
                    </li>
                    <li>
                      <font
                        face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                      >marketing opt-outs</font>
                    </li>
                  </ul>
                  <p></p>
                  <p>
                    <br />
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>User Settings</b>
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >The Settings menu in the Truck app gives users the the ability to set or update their location and contacts sharing preferences, and their preferences for receiving mobile notifications from Truck. Information on these settings, how to set or change these settings, and the effect of turning off these settings are described below.</font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>Location Information</b>
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Truck uses rider's device location services to make it easier to get a safe, reliable ride whenever you need one. Location data helps improve our services, including pickups, navigation, and customer support.</font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >You may enable/disable, or adjust, Truck's collection of rider location information at any time through the App settings of your devices.</font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <!-- <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>Share Live Location (Customers)</b>
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >If enabled for you your country, then you will see an option to disable it, If you have enabled the device location services on your mobile device, you may also enable Truck to share your location with your driver from the time you request a ride to the start of your trip. This makes it easier for your driver to pick you up.</font>
                  </p>-->
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <!-- <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >You may enable/disable location sharing with your driver at any time through the Privacy Settings menu in the Truck app. You may use the Truck app if you have not enabled location sharing, but it may be more difficult for your driver to locate you.</font>
                  </p>-->
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>Notifications: Account and Trip Updates</b>
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Truck provides users with trip status notifications and updates related to your account. These notifications are a necessary part of using the Truck app, and cannot be disabled. However, you may choose the method by which you receive these notifications through the Settings menu in the Truck app.</font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>Notifications: Discounts and News</b>
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >You may enable Truck to send you push notifications about discounts and news from Truck. You may enable/disable these notifications at any time through the Settings menu in the Truck app.</font>
                  </p>
                  <p>
                    <br />
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Most mobile platforms (iOS, Android, etc.) have defined certain types of device data that apps cannot access without your consent. And these platforms have different permission systems for obtaining your consent. The iOS platform will alert you the first time the Truck app wants permission to access certain types of data and will let you consent (or not consent) to that request. Android devices will notify you of the permissions that the Truck app seeks before you first use the app, and your use of the app constitutes your consent.</font>
                  </p>
                  <p>
                    <br />
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >After every trip, drivers and customers are able to rate each other, as well as give feedback on how the trip went. This two-way system holds everyone accountable for their behavior. Accountability helps create a respectful, safe environment for both drivers and customers.</font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Your rider rating is available in the Trip History menu of the Truck app.</font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >Your driver rating is available in the Trip History menu of the Truck app.</font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <b>EXPLANATIONS, COPIES AND CORRECTION</b>
                    </font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >You may request that Truck:</font>
                  </p>
                  <p></p>
                  <ul>
                    <li>
                      <span
                        style="font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif;"
                      >Provide a detailed explanation regarding the information Truck has collected about you and how it uses that information.</span>
                    </li>
                    <li>
                      <span
                        style="font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif;"
                      >Receive a copy of the information Truck has collected about you.</span>
                    </li>
                    <li>
                      <span
                        style="font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif;"
                      >Request correction of any inaccurate information that Truck has about you.</span>
                    </li>
                  </ul>
                  <p></p>
                  <p>
                    <span
                      style="font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif;"
                    >
                      <br />
                    </span>
                  </p>
                  <p>
                    <span
                      style="font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif;"
                    >You can make these requests by contacting Truck at support@truck.expert.</span>
                    <br />
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >You can also edit the name, phone number and email address associated with your account through the Profile menu in Truck's apps. You can also look up your trips, orders and deliveries history in the Truck apps.</font>
                  </p>
                  <p>
                    <font face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif">
                      <br />
                    </font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >MARKETING OPT-OUTS</font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >If enabled for your country you will get marketing emails, and you will also have and option to opt out from it.</font>
                  </p>
                  <p>
                    <font
                      face="Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
                    >You may opt out of receiving promotional emails from Truck here. You may also opt out of receiving emails and other messages from Truck by following the instructions in those messages. Please note that if you opt out, we may still send you non-promotional messages, such as receipts for your rides or information about your account.</font>
                  </p>
                  <p>
                    <br />
                  </p>
                </div>
              </div>
            </div>
            <hr />
          </div>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";

@Component
export default class Privacy extends Vue {}
</script>
